export default __webpack_public_path__ + "static/media/students-taking-the-test.5b87c416.gif";